module.exports = __webpack_public_path__ + "static/media/dark_dataak_logo.28b1324c.svg";